export function computeBackoffMs(attempt: number, baseMs = 1000, maxMs = 60_000): number {
  const safeAttempt = Math.max(1, Math.min(attempt, 16));
  const raw = baseMs * 2 ** (safeAttempt - 1);
  return Math.min(maxMs, raw);
}

export function createReconnectingTimer(
  onFire: () => void,
  options: { baseMs?: number; maxMs?: number; onDelay?: (ms: number) => void } = {},
): {
  schedule: (attempt: number) => void;
  cancel: () => void;
} {
  const baseMs = options.baseMs ?? 1000;
  const maxMs = options.maxMs ?? 60_000;
  let timer: ReturnType<typeof setTimeout> | null = null;

  return {
    schedule(attempt: number) {
      if (timer !== null) {
        clearTimeout(timer);
      }
      const delay = computeBackoffMs(attempt, baseMs, maxMs);
      options.onDelay?.(delay);
      timer = setTimeout(() => {
        timer = null;
        onFire();
      }, delay);
    },
    cancel() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    },
  };
}
